import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoConvenioPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoConvenioPage",
            ss: ss,
            ajax: {
                "url": ss.indexTipoConvenio(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'TipoConvenio', name: 'TipoConvenio', title: 'Tipo de Convenio' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            tipoConvenios: [],
            tipoConvenio: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newTipoConvenio() {
            this.tipoConvenio = {};
            this.$refs['frm-tipoConvenio'].show();
        },
        showTipoConvenio(id) {
            this.isLoading=true;
            this.ss.showTipoConvenio(id).then(
                (result) => {
                    let response = result.data;
                    this.tipoConvenio = response.data;
                    this.$refs['view-tipoConvenio'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoConvenio() {
            this.$refs['frm-tipoConvenio'].show();
            this.$refs['view-tipoConvenio'].hide();
        },
        cancelTipoConvenio() {
            if (this.tipoConvenio.id) {
                this.$refs['view-tipoConvenio'].show();
            }
            this.$refs['frm-tipoConvenio'].hide();
        },
        saveTipoConvenio() {
            this.ss.storeTipoConvenio(this.tipoConvenio).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipoConvenio'].hide();
                    this.$refs['datatable-tipoConvenio'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoConvenio() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyTipoConvenio(this.tipoConvenio)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipoConvenio'].hide();
                                this.$refs['datatable-tipoConvenio'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoConvenio').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoConvenio(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        }
    }
};
